import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../Store/actions';

import engine from '../Support/Engine';

import StandardField from '../UI/StandardField';
import Processing from '../UI/Processing';

class LoginForm extends Component {

	state = {
		form: {
			username: {
				name: 'Username',
				kind: 'email',
				error: false,
				errormsg: '',
				value: ''
			},
			password: {
				name: 'Password',
				kind: 'password',
				error: false,
				errormsg: '',
				value: ''
			}
		},
		processing: false,
		haserror: false,
		result: 0,
		message: ''
	}


	steFieldChanged = (event, field) => {

		const updatedForm = {
			...this.state.form
		};

		const updatedElement = {
			...this.state.form[field]
		};

		updatedElement.value = event.target.value;
		updatedForm[field] = updatedElement;

		this.setState({form: updatedForm});

	}


	steKeyboardAction = (event, field) => {
		if(event.key === 'Enter')
			this.login();
	}



	login = () => {

		const updatedState = {
			...this.state,
			form: {
				...this.state.form
			},
			processing: true,
			result: 0,
			haserror: false,
			message: ''
		};

		const login_blob = {};

		for(let f in this.state.form) {

			const updatedField = {
				...this.state.form[f],
				error: false,
				errormsg: ''
			};

			if(updatedField.value === '') {
				updatedField.error = true;
				updatedField.errormsg = 'Please enter your ' + updatedField.name.toLowerCase();
				updatedState.haserror = true;
			}
			else {
				login_blob[f] = updatedField.value;
			}

			updatedState.form[f] = updatedField;

		}

		this.setState(updatedState);

		if(updatedState.haserror) {
			updatedState.processing = false;
			return false;
		}

		engine.post('/account/login/', login_blob)
			.then(packet => {
				if(packet.data.result === true) {
					this.props.rdxSaveAuth(packet.data.response.t,packet.data.response.e * 1000); // For JS, translate seconds to milliseconds
					this.setState({...this.state, processing: false, result: 1});
				}
				else {
					this.setState({...this.state, processing: false, result: -1, message: packet.data.response});
				}
			})
			.catch(error => {
				this.setState({...this.state, processing: false, result: -1, message: 'Sorry, an unexpected error occured.'});
			});

	}



	render() {

		let fields = Object.keys(this.state.form)
			.map(field => {

				let classes = 'account-form__field';
				let errorLine = null;

				if(this.state.form[field].error && this.state.form[field].errormsg !== '') {
					classes += ' account-form__field--has-error';
					errorLine = <span className='account-form__field__error'>{this.state.form[field].errormsg}</span>;
				}

				return (
					<li key={field} className={classes}>
						<StandardField id={field} f={this.state.form[field]} handler={(event) => this.steFieldChanged(event,field)}
							kbhandler={(event) => this.steKeyboardAction(event,field)} />
						{errorLine}
					</li>
				);
			});

		let button = <div className='account-form__control__line'><button className='btn btn--full' onClick={this.login}>Sign in</button></div>;
		if(this.state.processing) button = <div className='account-form__control__line'><Processing /></div>;
		else if(this.state.result > 0) button = null;

		let serverResponse = null;
		if(this.state.result !== 0) {
			let srClass = 'account-form__control__line';
			if(this.state.result > 0) {
				srClass += ' account-form__control__line--positive';
				// Redirect to login page after a few seconds
			}
			if(this.state.result < 0) srClass += ' account-form__control__line--negative';
			serverResponse = <p className={srClass}>{this.state.message}</p>;
		}

		let root_classes = 'account-form';
		if(this.props.flair) root_classes += ' account-form--' + this.props.flair;

		return (
			<div className={root_classes}>
				<h5 className='account-form__title'>Firm Login</h5>
				<ul className='account-form__fields'>
					{fields}
				</ul>
				<div className='account-form__control'>
					{button}
					{serverResponse}
					<p className='account-form__control__line'><NavLink to='/reset-password'>Reset your password</NavLink></p>
				</div>
			</div>
		);
	}

}

const mapDispatchToProps = dispatch => {
	return {
		rdxSaveAuth: (token,expiry) => 	dispatch(actions.saveAuth(token,expiry))
	};
}



export default connect(null, mapDispatchToProps)(LoginForm);


// WEBPACK FOOTER //
// ./src/Blocks/LoginForm.js